<p-inputNumber
    inputStyleClass="shadow-none"
    [format]="false"
    [maxlength]="4"
    [(ngModel)]="yearInput" />
<i class="pi pi-chevron-left font-bold arrow-icon arrow-icon-left" (click)="decrementYear()"></i>
<i class="pi pi-chevron-right font-bold arrow-icon arrow-icon-right" (click)="incrementYear()"></i>
